import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import RouteChangeTracker from '@/components/common/RouteChangeTracker';
import { AdvisorProvider } from '@/context/AdvisorContext';
import { getFacebookPixelId } from '@/helpers/utils';
import type { RouterContext } from '@/lib/router/route-guards';
import initFacebookPixel from '@/services/facebookPixel';

const facebookPixel = initFacebookPixel(getFacebookPixelId());

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const showDevTools = import.meta.env.DEV && !import.meta.env.VITE_E2E_TESTING;

  return (
    <AdvisorProvider>
      <HeadContent />
      <RouteChangeTracker facebookPixel={facebookPixel} />
      <div className="page-container">
        <Outlet />
      </div>
      {showDevTools && <TanStackRouterDevtools position="bottom-right" />}
    </AdvisorProvider>
  );
}
